import React, {forwardRef, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import {Callback} from './types';
import {IState} from '../../store/reducers';
import SelectRecipients from './SelectRecipients';
import {useCurrentUser} from '../../hooks/use-user-current-workspace';

interface SelectRecipientsContainerProps {
  defaultValue: string[] | null | undefined; // array of emails
  forceDefault?: boolean;
  onChange: Callback;
  disabled?: boolean;
  placeholder?: string;
}

const SelectRecipientsContainer = forwardRef(({
  defaultValue: defaultValue_,
  forceDefault = true,
  disabled = false,
  onChange,
  placeholder,
}: SelectRecipientsContainerProps, ref: any) => {
  /*
   * Don't forget to dispatch the action to fetch the recipients in the parent component.
   * We don't want to fetch the recipients in this component because it will be rendered multiple times.
   *
   * @TODO - This can be a hook.
   */
  const recipients = useSelector((state: IState) => state.users.recipients);
  const currentUser = useCurrentUser();
  const [init, setInit] = useState(false);
  const [defaultValue, setDefaultValue] = useState<string[] | null | undefined>(defaultValue_);

  useEffect(() => {
    if (init || !currentUser) {
      return;
    }
    setInit(true);

    if (forceDefault && (!defaultValue || defaultValue.length === 0)) {
      // If defaultValue is not provided, set the current user as the default value.
      setDefaultValue([currentUser?.email as string]);
      /*
       * Setting defaultValue to current user's email, will not trigger
       *   initial `onChange` in `SelectRecipients` component.
       */
      onChange([currentUser?.email as string]);
    }

  }, [defaultValue, currentUser, init]);

  if (!init) {
    return null;
  }

  return (
    <SelectRecipients
      ref={ref}
      defaultValue={defaultValue || []}
      disabled={disabled}
      recipients={recipients}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
});

export default SelectRecipientsContainer;
